




























import { Component, Vue } from 'vue-property-decorator';

import VRPlayerModule from '@flow/vr-player';

import Store from '@/store';
import VRPlayerStoreModule from '@/store/modules/vr-player';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Component({
  components: {
    VRPlayerModule,
  },
})
export default class VRPlayer extends Vue {
  private isFullscreen = false;
  private isInitialized = false;
  private activeNavName: string | (string | null)[] | null | undefined = null;
  private activeMinimap: boolean | null | undefined = null;
  private activeThemeIndex: number | null | undefined = null;
  private lang: string | (string | null)[] | null | undefined = null;
  private projectID: string | undefined;
  private startID: string | (string | null)[] | null | undefined = null;
  private tourID: number | undefined;
  private playerID: number | undefined;
  private playerName: string | undefined;
  private totalTimer: any;
  private latestTime = 0;
  private latestScene: any;
  private latestLayer: any;

  get module() {
    return {
      id: '00000000000000000000000000', // string (UUID)
      name: 'first video module',
      type: 'VR_PLAYER', // string (constatnt) : IMAGE, HTML, VIDEO, VR_PLAYER
      description: 'video module description',
      options: {
        vrPlayerModel: this.$store.state.vrPlayer.model,
      },
    };
  }

  get fullscreenIconPath() {
    if (this.isFullscreen) {
      return '/a_frame.svg';
    } else {
      return '/a_screen.svg';
    }
  }

  fullscreen() {
    this.isFullscreen = !this.isFullscreen;

    const elem = this.$el as any;

    if (!document.fullscreenElement && !(document as any).msFullscreenElement) {
      const fullscreenApi = (() => {
        if (elem.msRequestFullscreen) {
          return 'msRequestFullscreen';
        } else {
          return 'requestFullscreen';
        }
      })();

      elem[fullscreenApi]().catch((err) => {
        window.parent.postMessage(
          {
            vrPlayerData: {
              fullScreen: this.isFullscreen,
              href: window.location.href,
            },
          },
          '*',
        );
      });
    } else {
      const exitFullscreenApi = (() => {
        if ((document as any).msExitFullscreen) {
          return 'msExitFullscreen';
        } else {
          return 'exitFullscreen';
        }
      })();

      window.document[exitFullscreenApi]();
    }
  }

  onPlayerSceneChange({ beforeScene, nowScene }) {
    // gtm 이벤트 추가 - Scene 입장/퇴장 시 이벤트 발생

    this.tourID = this.$store.state.vrPlayer.model.id;
    clearInterval(this.totalTimer);
    this.sendIntermediateLayerTime(nowScene, nowScene.layers[0]);

    /* eslint-disable */
    const template = {
      event: 'moduleVRPlayerLayerViewEvent',
      categoryProjectID: this.projectID,
      categoryStageID: this.tourID + 'STAGE',
      categoryTourID: this.tourID,
      action: 'VRPlayer_Layer_View',
      labelSceneID: nowScene.id,
      labelLayerID: nowScene.layers[0].id,
      labelUserID: this.userID,
    };

    if (this.tourID) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(template);
    }

    this.setTimer(nowScene, nowScene.layers[0]);
  }

  onPlayerHotspotTrigger({ hotspotData }) {
    const template = {
      event: 'moduleVRPlayerHotspotEvent',
      categoryProjectID: this.projectID,
      categoryStageID: this.tourID + 'STAGE',
      categoryTourID: this.tourID,
      action: 'VRPlayer_Hotspot',
      labelSceneID: hotspotData.sceneID,
      labelHotspotType: hotspotData.hotspotType,
      labelHotspotID: hotspotData.id,
      labelUserID: this.userID,
    };

    if (this.tourID && hotspotData.sceneID) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(template);
    }
  }

  onPlayerLayerChange({ nowScene, nowLayer }) {
    // gtm 이벤트 추가 - Layer 변경시 시 이벤트 발생
    clearInterval(this.totalTimer);
    this.sendIntermediateLayerTime(nowScene, nowLayer);

    const template = {
      event: 'moduleVRPlayerLayerViewEvent',
      categoryProjectID: this.projectID,
      categoryStageID: this.tourID + 'STAGE',
      categoryTourID: this.tourID,
      action: 'VRPlayer_Layer_View',
      labelSceneID: nowScene.id,
      labelLayerID: nowLayer.id,
      labelUserID: this.userID,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(template);

    this.setTimer(nowScene, nowLayer);
  }

  setTimer(scene, layer) {
    this.totalTimer = setInterval(() => {
      this.latestTime = Date.now();
      this.sendGTMLayerTime(scene, layer, 15000);
    }, 15000);
  }

  sendIntermediateLayerTime(scene, layer) {
    let currentTime: number = Date.now();

    if (this.latestScene && this.latestLayer) {
      this.sendGTMLayerTime(
        this.latestScene,
        this.latestLayer,
        currentTime - this.latestTime,
      );
    }
    this.latestScene = scene;
    this.latestLayer = layer;
    this.latestTime = currentTime;
  }

  sendGTMLayerTime(scene, layer, ms) {
    let seconds = Math.round(ms / 1000);

    if (this.tourID && seconds) {
      const template = {
        event: 'moduleVRPlayerLayerTimeEvent',
        categoryProjectID: this.projectID,
        categoryStageID: this.tourID + 'STAGE',
        categoryTourID: this.tourID,
        action: 'VRPlayer_Layer_Time',
        labelSceneID: scene.id,
        labelLayerID: layer.id,
        labelUserID: this.userID,
        valueTime: Math.round(ms / 1000),
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(template);
    }
  }

  sendGTMModuleView(player) {
    const template = {
      event: 'moduleViewEvent',
      categoryProjectID: this.projectID,
      categoryStageID: this.tourID + 'STAGE',
      action: 'Module_View',
      labelModuleID: player.id,
      labelModuleType: 'VR_PLAYER',
      labelModuleName: player.title,
    };

    this.playerID = player.id;
    this.playerName = player.name;

    if (this.projectID) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(template);
    }
  }

  sendGTMModuleTime() {
    if (this.projectID) {
      this.totalTimer = window.setInterval(() => {
        const template = {
          event: 'moduleTimeEvent',
          categoryProjectID: this.projectID,
          categoryStageID: this.tourID + 'STAGE',
          action: 'Module_Time',
          labelModuleID: this.playerID,
          labelModuleType: 'VR_PLAYER',
          labelModuleName: this.playerName,
          valueTime: 15000 / 1000,
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(template);
      }, 15000);
    }
  }

  created() {
    Store.registerModule('vrPlayer', VRPlayerStoreModule);
  }

  fullscreenHandler(e) {
    if (document.fullscreenElement) {
      this.isFullscreen = true;
    } else {
      this.isFullscreen = false;
    }
  }

  async mounted() {
    if (this.$route.query.active) {
      this.activeNavName = this.$route.query.active;
    }

    if (this.$route.query.minimap) {
      this.activeMinimap = !!this.$route.query.minimap;
    }

    if (this.$route.query.themeIndex) {
      this.activeThemeIndex = Number(this.$route.query.themeIndex);
    }

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang;
    }

    if (this.$route.query.startID) {
      this.startID = this.$route.query.startID;
    }

    await this.$store.dispatch('vrPlayer/init');

    this.projectID = this.$store.state.vrPlayer.model.projectID;
    this.sendGTMModuleView(this.$store.state.vrPlayer.model);
    this.sendGTMModuleTime();
    this.latestTime = Date.now();
    this.latestScene = null;
    this.latestLayer = null;

    document.addEventListener('fullscreenchange', this.fullscreenHandler, false);
  }

  private destroyed() {
    Store.unregisterModule('vrPlayer');
    document.removeEventListener('fullscreenchange', this.fullscreenHandler);
  }

  get userID() {
    return this.$store.state.vrPlayer.userInfo.id;
  }
}
